import { useState } from 'react';
import { Route, NavLink, Switch, useParams, useLocation } from 'react-router-dom';
import { Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';
import AllSuites from './Suites';
import SingleSuite from './SingleSuite';

const TabContainer = styled.div`
	margin: 15px -10px 0 -10px;
	padding-bottom: 10px;
	border-bottom: 2px solid rgba(34,36,38,.15);
`;

const CustomNavLink = styled(NavLink)`
	border-bottom-color: transparent;
	border-bottom-style: solid;
	border-bottom-width: 2px;
	border-radius: 0;
	margin: 0 0 -2px;
	transition: color .1s ease;
	color: rgba(0,0,0,.87);
	padding: 10px;
	font-size: 1em;

	:hover {
		color: rgba(0,0,0,.95);
	}

	:last-child {
		margin-left: 20px;
	}
`;

const Filter = styled.span`
	float : right;
	margin-right: 20px;
`;

const active_tab_style = {
	color           : `rgba(0,0,0,.95)`,
	fontWeight      : 700,
	borderColor     : `#1b1c1d`,
	backgroundColor : `transparent`,
};

function Suites() {
	const location = useLocation();
	const path     = `/suites`;
	const { id }   = useParams();
	const [ selected_suite_params, setSelectedSuiteParams ] = useState(Object.fromEntries(new URLSearchParams(window.location.search)));
	const [ selected_filter, setSelectedFilter ]            = useState(`7 day`);

	const suite_link = id !== `suites` ? `${path}/single?${new URLSearchParams(selected_suite_params)}` : `${path}/none`;

	function handleViewSuite(params) {
		setSelectedSuiteParams(params);
	}

	function handleChangeFilter(e, { value }) {
		setSelectedFilter(value);
	}

	const filter_options = [
		{
			key   : `24h`,
			text  : `24 Hours`,
			value : `24 hour`,
		},
		{
			key   : `3d`,
			text  : `3 Days`,
			value : `3 day`,
		},
		{
			key   : `7d`,
			text  : `7 Days`,
			value : `7 day`,
		},
		{
			key   : `21d`,
			text  : `21 Days`,
			value : `21 day`,
		},
	];

	return (
		<div>
			<TabContainer>
				<CustomNavLink
					isActive={(match, location) => {
						return location.pathname === path;
					}}
					activeStyle={active_tab_style}
					to={path}
				>Suites</CustomNavLink>
				<CustomNavLink
					isActive={(match, location) => {
						return location.pathname !== path;
					}}
					activeStyle={active_tab_style}
					to={suite_link}
				>Selected Suite</CustomNavLink>

				{location.pathname === `/suites` &&
					<Filter>
						<Dropdown
							direction="left"
							floating
							options={filter_options}
							value={selected_filter}
							onChange={handleChangeFilter}
						/>
					</Filter>
				}
			</TabContainer>

			<Switch>
				<Route exact path={path}>
					<AllSuites
						handleViewSuite={handleViewSuite}
						selected_filter={selected_filter}
					/>
				</Route>

				<Route exact path={`${path}/single`}>
					<SingleSuite />
				</Route>
			</Switch>
		</div>
	);
}

export default Suites;
